import Settings from 'configs/Settings';

export const getSubdomainByUrl = () => {
  const subdomainRule = new RegExp(`^([a-zA-Z0-9-]+).${Settings.domain}$`);
  const domain = document.location.hostname;
  const subdomain = subdomainRule.exec(domain);

  if (subdomain) {
    return subdomain[1];
  }

  return subdomain;
};
